module.exports = __webpack_public_path__ + "media/images/invoice_logo-d9a7ca1efa3064c2f45137efec39e1c8.png";